module.exports = __webpack_public_path__ + "assets/img/21112fe2d32206a0a9f457f9a4e18536.png";